import { SvgStyled } from '../../../components/Global/Atomics/SvgStyled';

const Edit = (props) => {
    return (
        <SvgStyled
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            className={props.cssClasses ? `icon ${props.cssClasses}` : 'icon'}
            viewBox="0 0 40 40"
            width={props.size}
            height={props.size}>
            <path fillRule="evenodd" clipRule="evenodd"
                d="M27.6617 6.18171C27.4287 5.93943 27.0679 5.93943 26.8349 6.18171L9 24.73V30L13.9904 30L31.8094 11.4682C32.0635 11.2039 32.0635 10.7596 31.8094 10.4953L27.6617 6.18171ZM25.3933 4.79549C26.4131 3.73484 28.0835 3.73484 29.1034 4.79549L33.251 9.10906C34.2497 10.1476 34.2497 11.8159 33.251 12.8544L15.1369 31.6931C14.9484 31.8891 14.6881 32 14.4161 32L8.00001 32C7.73479 32 7.48043 31.8946 7.2929 31.7071C7.10536 31.5196 7 31.2652 7 31V24.3272C7 24.0688 7.10005 23.8204 7.27917 23.6341L25.3933 4.79549ZM29 37H7C6.44772 37 6 36.5523 6 36C6 35.4477 6.44772 35 7 35L29 35C29.5523 35 30 35.4477 30 36C30 36.5523 29.5523 37 29 37Z"
                fill={props.color ? props.color : "white"} />
        </SvgStyled>
    );
};

export default Edit;
